const STORAGE_KEY = 'chunk-reload-at';
const MIN_INTERVAL_MS = 60_000;

/**
 * Após um deploy, a aba que ficou aberta ainda aponta pros chunks antigos
 * (hash no nome). Ao navegar pra uma rota lazy o import() falha com
 * "Failed to fetch dynamically imported module". O Vite avisa via
 * `vite:preloadError`; recarregar traz o manifest novo. O carimbo em
 * sessionStorage evita loop se o reload também falhar (CDN/nginx fora).
 */
export function setupChunkReload(): void {
    window.addEventListener('vite:preloadError', (event) => {
        if (reloadedRecently()) return;

        event.preventDefault();
        markReload();
        window.location.reload();
    });
}

function reloadedRecently(): boolean {
    try {
        const last = Number(sessionStorage.getItem(STORAGE_KEY) ?? 0);
        return Date.now() - last < MIN_INTERVAL_MS;
    } catch {
        return false;
    }
}

function markReload(): void {
    try {
        sessionStorage.setItem(STORAGE_KEY, String(Date.now()));
    } catch {
        // sem storage (modo privado) segue sem proteção de loop
    }
}
